import axiosInstance from "./axiosInstance";

const getAllPostsById = async (userId: number, pageParam: number = 1) => {
  const accessToken = localStorage.getItem("accessTokenGC");
  try {
    const {data} = await axiosInstance.get(
      `/api/posts/${userId}?page=${pageParam}&limit=5`,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
        },
      }
    );
    return {
      posts: data.posts,
      nextPage: pageParam + 1,
      totalPages: data.pagination.totalPages,
    };
  } catch (error) {
    console.error("Error fetching posts", error);
    throw new Error("Error fetching user posts.");
  }
};

export default getAllPostsById;
